window.switchHeaderBlue = function (open) {
    // var $realMenu = $('#rd-real-menu');
    // var $header = $('#rd-header');

    // function isHoverCapable() {
    //     return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    // }

    // function onMouseEnter() {
    //     if (!isHoverCapable()) return;
    //     if ($realMenu.hasClass('blue_style')) {
    //         $header.data('had_blue_style', $header.hasClass('blue_style'));
    //         $header.removeClass('blue_style');
    //     }
    // }

    // function onMouseLeave() {
    //     if (!isHoverCapable()) return;
    //     if ($realMenu.hasClass('blue_style')) {
    //         if ($header.data('had_blue_style')) {
    //             $header.addClass('blue_style');
    //         }
    //     }
    // }

    // if (open) {
    //     $header.addClass('blue_style');
    //     $realMenu.addClass('blue_style');
    //     $('.rd-blue').addClass('blue');
    //     // 只有在支援 hover 的裝置才綁定
    //     if (isHoverCapable()) {
    //         $realMenu.off('mouseenter.switchHeaderBlue').on('mouseenter.switchHeaderBlue', onMouseEnter);
    //         $realMenu.off('mouseleave.switchHeaderBlue').on('mouseleave.switchHeaderBlue', onMouseLeave);
    //     }
    // } else {
    //     $header.removeClass('blue_style');
    //     $realMenu.removeClass('blue_style');
    //     $('.rd-blue').removeClass('blue');
    //     // 移除綁定的事件
    //     $realMenu.off('.switchHeaderBlue');
    //     // 清掉記錄的 state
    //     $header.removeData('had_blue_style');
    // }
}

window.share = function ({ type, url = null }) {

    if (url === null) {
        url = location.href;//window.location.hostname;
    }

    switch (type) {
        case "line":
            window.open('https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(url));
            break;
        case "linekedin":
            window.open('https://www.linkedin.com/shareArticle?url=' + encodeURIComponent(url));
            break;
    }
    return false;
}

// 鎖捲軸
// 例: 如果要鎖 body:
// var body = $('body');
// lockScroll(body);
window.lockScroll = function (target) {
    var scroll_top = $(window).scrollTop();
    var lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        $(target).data('lock_count', 1);

        target.data('scroll_style', target.attr('style'));
        target.data('scroll_top', scroll_top);
        target.css({ "overflow": "hidden", "position": "fixed", "top": (scroll_top * -1) + "px" });
    } else {
        $(target).data('lock_count', lock_count + 1);
    } // end of if

} // end of function

// 開捲軸 - 如果鎖了3次, 需要呼叫此　function 3 次後才會解鎖
//
// target　要解開鎖的目標
// unlock_all 強制解鎖, 無視鎖被加了幾次
window.unlockScroll = function (target, unlock_all) {

    var lock_count = $(target).data('lock_count');

    if (typeof lock_count === 'undefined' || lock_count === 0) {
        lock_count = 0;
        $(target).data('lock_count', 0);
    } else {
        lock_count = lock_count - 1;
        $(target).data('lock_count', lock_count);
    } // end of if

    if (lock_count === 0 || (typeof unlock_all !== 'undefined' && unlock_all === true)) {
        var scroll_top = target.data('scroll_top');
        var scroll_style = target.data('scroll_style');

        if (scroll_style) {
            target.attr('style', scroll_style);
        } else {
            target.removeAttr('style');
        }

        $(window).scrollTop(scroll_top);
    } // end of if

} // end of function
